
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { RoleSelect } from "./RoleSelect";

interface UserInfoProps {
  firstName?: string;
  lastName?: string;
  username?: string;
  role: string;
  dni?: string | null;
  isMobile: boolean;
  onRoleChange: (value: string) => void;
  canEditRole?: boolean;
}

export const UserInfo = ({
  firstName,
  lastName,
  username,
  role,
  dni,
  isMobile,
  onRoleChange,
  canEditRole = true,
}: UserInfoProps) => {
  const displayName = firstName && lastName 
    ? `${firstName} ${lastName}` 
    : username || 'Usuario sin nombre';

  const initials = firstName && lastName 
    ? `${firstName[0]}${lastName[0]}` 
    : username ? username[0].toUpperCase() : 'U';

  const getRoleColor = (role: string) => {
    switch (role) {
      case 'admin': return 'bg-red-500';
      case 'manager': return 'bg-blue-500';
      case 'profesor': return 'bg-green-500';
      default: return 'bg-gray-500';
    }
  };

  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'admin': return 'Administrador';
      case 'manager': return 'Manager';
      case 'profesor': return 'Profesor';
      default: return 'Socio';
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <span className="font-medium text-sm sm:text-base">{displayName}</span>
      {dni && (
        <span className="text-xs text-muted-foreground">DNI: {dni}</span>
      )}
      <Badge variant="outline" className={`${getRoleColor(role)} text-white text-xs w-fit`}>
        {getRoleLabel(role)}
      </Badge>
    </div>
  );
};
